export const Breadcrumb = ({ data }) => {
  return (
    <div className="breadcrumb-warp">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          {data.map((item, index) => {
            const lastItem = index === data.length - 1;

            return (
              <li className={`breadcrumb-item ${lastItem ? "active" : ""}`}>
                {item.link ? <a href={item.link}>{item.label}</a> : <>{item.label}</>}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};
